<template>
    <div class="margin_horizontal">
      <div class="pageTitle">
        <span class="md-title">{{ $t("accessDenied.title") }}</span>
      </div>
      <div class="text-center">
        <p>{{ $t("accessDenied.msg")}}</p>
      </div>
  </div>
</template>

<script>
export default {

};
</script>
